module.exports = __webpack_public_path__ + "static/media/DownloadNow_elImage2_399085.8801728a.png";